import React from 'react';
import Carousel from 'react-bootstrap/Carousel';


import banner1 from '../img/banner1.jpg';
import banner2 from '../img/banner2.jpg';

const Carousal = () => {
    return (
        <Carousel>
            <Carousel.Item>
                <img className="carousel-img" src={banner1} alt="First slide" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="carousel-img" src={banner2} alt="Second slide" />
            </Carousel.Item>
        </Carousel>
    );
}

export default Carousal;
